export const iconFontAwesomeMaritimeShip = (
	<i className="fa-solid fa-ship"></i>
);
